import { createSelector } from 'reselect';

export const searchOptionsSelector = state =>
  state.getIn(['app', 'litigation', 'arbitrator', 'searchOptions']);
export const fieldsSelector = state =>
  state.getIn(['app', 'litigation', 'arbitrator', 'fields']);
export const arbitratorsSelector = state =>
  state.getIn(['app', 'litigation', 'arbitrator', 'arbitratorList']);
export const arbitratorSelector = state =>
  state.getIn(['app', 'litigation', 'arbitrator', 'arbitrator']);
export const notesSelector = state =>
  state.getIn(['app', 'litigation', 'arbitrator', 'notes']);
export const arbitratorSearchFilterFormSelector = state =>
  state.getIn(['form', 'litigationArbitratorSearch']);
export const arbitratorDetailFormSelector = state =>
  state.getIn(['form', 'litigationArbitratorDetail']);
export const getSearchArbitrators = state =>
  state.getIn(['app', 'litigation', 'arbitrator', 'searchArbitrators']);
export const getNewArbitrator = state =>
  state.getIn(['app', 'litigation', 'arbitrator', 'newArbitrator']);

export const arbitratorStateSelector = state =>
  state.getIn(['app', 'litigation', 'arbitrator']).toJS().state;
export const activeArbitratorSelector = state =>
  state.getIn(['app', 'litigation', 'arbitrator', 'activeArbitrator']);

// Arbitrator lookup modal
export const arbitratorLookupModalOpenSelector = state =>
  state.getIn([
    'app',
    'litigation',
    'arbitrator',
    'arbitratorLookupModal',
    'open',
  ]);
export const arbitratorLookupModalModeSelector = state =>
  state.getIn([
    'app',
    'litigation',
    'arbitrator',
    'arbitratorLookupModal',
    'mode',
  ]);
export const arbitratorLookupModalStateSelector = state =>
  state.getIn([
    'app',
    'litigation',
    'arbitrator',
    'arbitratorLookupModal',
    'state',
  ]);
export const arbitratorLookupModalDataSelector = state =>
  state.getIn([
    'app',
    'litigation',
    'arbitrator',
    'arbitratorLookupModal',
    'data',
  ]);
export const arbitratorLookupModalRecordCountSelector = state =>
  state.getIn([
    'app',
    'litigation',
    'arbitrator',
    'arbitratorLookupModal',
    'count',
  ]);
export const arbitratorLookupModalSelectionSelector = state =>
  state.getIn([
    'app',
    'litigation',
    'arbitrator',
    'arbitratorLookupModal',
    'selection',
  ]);

export const getArbitratorSelectorData = createSelector(
  [arbitratorSelector],
  arbitratorIm =>
    arbitratorIm.get('data') ? arbitratorIm.get('data').toJS() : null,
);

// Owner create modal
export const arbitratorCreateModalOpenSelector = state =>
  state.getIn([
    'app',
    'litigation',
    'arbitrator',
    'arbitratorCreateModal',
    'open',
  ]);

export const arbitratorCreateModalResultSelector = state =>
  state
    .getIn(['app', 'litigation', 'arbitrator', 'arbitratorCreateModal'])
    .toJS().data;
